import PrizeReports from "../components/report-prize-logs";

const PrizeRegistersReportPage = () => {
  return <PrizeReports />;
};

export default PrizeRegistersReportPage;
